// ContraindicationsDialog.jsx (controlled)
import * as React from 'react';
import {
  Dialog,
  DialogContent,
  DialogBody,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Separator } from '@/components/ui/separator';
import { Checkbox } from '@/components/ui/checkbox';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Info, AlertCircle } from 'lucide-react';

export default function SgkDialog({ open, onOpenChange, onAccept }) {
  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        onOpenChange(isOpen); // bubble to parent
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Dėmesio!</DialogTitle>
        </DialogHeader>
        <DialogBody className="space-y-6 max-h-[75dvh] overflow-y-auto">
          <div className="space-y-4 text-center">
            Prašome patvirtinti, kad registracijos metu nesate prisirašę prie
            mūsų klinikos ir/ar šeimos gydytojo. Prisirašę pacientai gali
            registruotis tik į PSDF kompensuojamus registracijos laikus.
          </div>
        </DialogBody>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Grįžti
          </Button>
          <Button
            variant="secondary"
            onClick={() => {
              onOpenChange(false);
              onAccept(true);
            }}
          >
            Tvirtinu
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
